import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trusticons',
  templateUrl: './trusticons.component.html',
  styleUrls: ['./trusticons.component.scss']
})
export class TrusticonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
